const getDefaultState = () => {
  return {
    isPc: true,
    isMobile: false,
    isPhone: false,
    isFullHeader: false,
  };
};

const state = getDefaultState();

const getters = {
  getIsPc: (state, getter, rootState) => {
    return state.isPc;
  },
  getIsMobile: (state, getter, rootState) => {
    return state.isMobile;
  },
  getIsPhone: (state, getter, rootState) => {
    return state.isPhone;
  },
  getIsFullHeader: (state, getter, rootState) => {
    return state.isFullHeader;
  },
};

//commit 呼叫
const mutations = {
  setIsPc(state, isPc) {
    state.isPc = isPc;
  },

  setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  },

  setIsPhone(state, isPhone) {
    state.isPhone = isPhone;
  },

  setIsFullHeader(state, isFullHeader) {
    state.isFullHeader = isFullHeader;
  },

  resetState(state) {
    const initState = getDefaultState();
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key];
    });
  },
};

//用dispatch 呼叫
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
